import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'

import { actions as LKModalActions } from 'shared/LKModal'
import { destroy } from 'shared/LKGrid'
import { fetchSFM, getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
import withLookups, { LookupType } from 'shared/containers/withLookups'
import { actions as DetailsContainerActions } from '../DetailsContainer'
import { translateLKMessage } from './translate'
import { addPermission } from 'src/store/client'

const FETCHER_NAME = 'ClientPermissionAdd'

const mapStateToProps = (state) => ({
  loading: getPending(FETCHER_NAME)(state),
})

const mapDispatchToProps = (dispatch, { ID, hash }) => ({
  addPermission: async (permissionID) => {
    // dispatch(
    //   fetchSFM({
    //     instanceName: FETCHER_NAME,
    //     callApi: Client.addPermission,
    //     callApiArgs: [
    //       {
    //         ClientID: ID,
    //         HashSum_ClientID_: hash,
    //         ID: permissionID,
    //       },
    //     ],
    //     resolve: () => {
    //       dispatch(LKModalActions.close('ClientPermissionAdd'))

    //       dispatch(destroy('ClientPermissionAdd'))

    //       dispatch(
    //         DetailsContainerActions.fetchPage({
    //           type: 'Client',
    //           ID,
    //           hash,
    //           page: 'accessperms',
    //           permission: 'VIEW_RL',
    //         }),
    //       )
    //     },
    //     reject: (error) => {
    //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
    //     },
    //   }),
    // )
    //UPDATED API REQUEST client_oper page: accesspermadd
    try {
      const res = await dispatch(
        addPermission({
          ClientID: ID,
          HashSum_ClientID_: hash,
          ID: permissionID,
        }),
      )
      if (addPermission.fulfilled.match(res)) {
        dispatch(LKModalActions.close('ClientPermissionAdd'))

        dispatch(destroy('ClientPermissionAdd'))

        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Client',
            ID,
            hash,
            page: 'accessperms',
            permission: 'VIEW_RL',
          }),
        )
      } else if (addPermission.rejected.match(res)) {
        dispatch(LKModalActions.openInfo(translateLKMessage(res.payload)))
      }
    } catch (error) {
      dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
    }
  },
})

export default flowRight(connect(mapStateToProps, mapDispatchToProps), withLookups({ type: LookupType.Users }))
